var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { hidePreloader, showPreloader } from "../preloader";
import ajax from "../ajax";
import { showModalFromHtml } from "../modal";
import { updateCartFromHTML } from "../cart";
import EventBus from "../../events/EventBus";
import CartEventBus from "../../screens/cart/CartEventBus";
import { addGlobalLiveEventListener } from "../../utils";
/**
 * Единая функция добавления товаров и сетов в корзину
 */
export function handleAddToCartButtonClick(_a) {
    return __awaiter(this, arguments, Promise, function (_b) {
        var payload, response, result, productId, errorMessage, error_1;
        var _c, _d;
        var id = _b.id, _e = _b.type, type = _e === void 0 ? 'offer' : _e, _f = _b.cnt, cnt = _f === void 0 ? 1 : _f, _g = _b.silent, silent = _g === void 0 ? false : _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    showPreloader();
                    _h.label = 1;
                case 1:
                    _h.trys.push([1, 4, 5, 6]);
                    payload = { cnt: cnt };
                    if (id) {
                        payload.id = id;
                    }
                    if (type !== 'offer') {
                        payload.type = type;
                    }
                    return [4 /*yield*/, ajax('/api/cart/add', payload, { dataType: 'json' })];
                case 2:
                    response = _h.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    result = _h.sent();
                    if (result.ok) {
                        if (result.basket_block) {
                            updateCartFromHTML(result.basket_block);
                        }
                        if (!silent && result.html) {
                            showModalFromHtml(result.html);
                        }
                        CartEventBus.emit('cart:refresh');
                        // Если в ответе пришло обновленное состояние сета
                        if (result.data) {
                            EventBus.emit('set:update', result.data);
                        }
                        productId = (_c = result.product_id) !== null && _c !== void 0 ? _c : id;
                        (_d = window.fbq) === null || _d === void 0 ? void 0 : _d.call(window, 'track', 'AddToCart', {
                            content_ids: [productId],
                            content_type: 'product',
                            contents: [{ id: productId, quantity: cnt }]
                        });
                        return [2 /*return*/, true];
                    }
                    errorMessage = result.error
                        ? Object.values(result.error)[0]
                        : 'Ошибка при добавлении товара в корзину';
                    console.warn(errorMessage);
                    // TODO (toast): Показать ошибку добавления в корзину (errorMessage)
                    return [2 /*return*/, false];
                case 4:
                    error_1 = _h.sent();
                    console.error('Ошибка при добавлении в корзину:', error_1);
                    // TODO (toast): Показать системную ошибку/сетевой сбой ('Произошла системная ошибка при добавлении товара в корзину')
                    return [2 /*return*/, false];
                case 5:
                    hidePreloader();
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    });
}
/**
 * Добавление в корзину по кнопке: тип позиции берётся из data-type (по умолчанию — обычный товар), идентификатор — из data-id
 */
export function addToCartFromElement(element) {
    return __awaiter(this, void 0, Promise, function () {
        var type, id, button;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    type = (element.dataset.type || 'offer');
                    id = type === 'offer' ? parseInt((_a = element.dataset.id) !== null && _a !== void 0 ? _a : '', 10) : element.dataset.id;
                    button = element instanceof HTMLButtonElement ? element : null;
                    if (type === 'offer' && !id) {
                        console.warn('Не указан ID товара для добавления в корзину', element);
                        return [2 /*return*/, false];
                    }
                    if (button) {
                        button.disabled = true;
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, handleAddToCartButtonClick({ id: id, type: type })];
                case 2: return [2 /*return*/, _b.sent()];
                case 3:
                    if (button) {
                        button.disabled = false;
                    }
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function initAddToCartButtons() {
    addGlobalLiveEventListener('click', '.to_basket', function (e) {
        e.preventDefault();
        addToCartFromElement(this);
    });
}
